var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3232_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7627 27.2693H23.024V19.844C23.024 18.0733 22.988 15.7947 20.5547 15.7947C18.084 15.7947 17.7067 17.7213 17.7067 19.7133V27.2693H12.968V12H17.52V14.0813H17.5813C18.2173 12.8813 19.764 11.6147 22.0747 11.6147C26.876 11.6147 27.764 14.7747 27.764 18.888L27.7627 27.2693ZM7.616 9.91067C6.09067 9.91067 4.86533 8.676 4.86533 7.15733C4.86533 5.64 6.092 4.40667 7.616 4.40667C9.136 4.40667 10.368 5.64 10.368 7.15733C10.368 8.676 9.13467 9.91067 7.616 9.91067ZM9.992 27.2693H5.24V12H9.992V27.2693ZM30.1333 0H2.86133C1.556 0 0.5 1.032 0.5 2.30533V29.6947C0.5 30.9693 1.556 32 2.86133 32H30.1293C31.4333 32 32.5 30.9693 32.5 29.6947V2.30533C32.5 1.032 31.4333 0 30.1293 0H30.1333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3232_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinlogo);
export default __webpack_public_path__ + "static/media/linkedin logo.365f1c1c2e982816250e27e71c7c7469.svg";
export { ForwardRef as ReactComponent };